/**
 * Created by Claude on 13.02.2026
 */

const IslandDecorationHelper = {
    getString: function (period, prefix, suffix) {
        return `${prefix}${period.charAt(0).toUpperCase()}${period.slice(1)}${suffix || ""}`;
    },

    getWindowBundle: function () {
        return bundles.island_decoration_main_window;
    },

    getPreviewBundle: function () {
        return bundles.island_decoration_preview_window;
    },

    getStartBundle: function () {
        return bundles.island_decoration_start_window;
    },

    getItemsBundle: function (period) {
        return bundles[`island_decoration_items_${period}`];
    },

    hasWindowBundles: function (period) {
        return Boolean(bundles[`island_decoration_items_${period}`]
            && bundles[`island_decoration_illustrations_${period}`]);
    },

    getWindowIllustrationsBundle: function (period) {
        return `island_decoration_illustrations_${period}`;
    },

    getDecorBundle: function (period) {
        return bundles[`island_decoration_decor_${period}`];
    },

    getGuideWindow: function (mission, period) {
        return mission.guideWindow || {
            name: IslandDecorationHelper.getString(period, "IslandDecorationGuideWindow"),
            title: IslandDecorationHelper.getString(period, "Missions.IslandDecoration", ".Title"),
            bundle: bundles[`island_decoration_guide_window_${period}`]
        };
    }
};
